import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { startSessionManager } from '@/utils/session'
import '@/styles/tokens.css'
import '@/styles/responsive.css'

Vue.config.productionTip = false

startSessionManager(router)

new Vue({ router, render: h => h(App) }).$mount('#app')
